import { appInfo } from "src/constants/AppInfo"
import { execApi } from "src/apis/execApi"
import { getUnreadThreadMessageCountByMailIds } from "src/aws/customAPI"

type Params = {
  accessToken: string
  accountId: string
  contactIds?: string[]
}

export const getUnreadThreadCountFromDynamoDB = async ({
  accessToken,
  accountId,
  contactIds,
}: Params): Promise<any> => {
  if (contactIds != null && contactIds.length === 0) {
    return { buckets: [] }
  }

  try {
    // Call the new DynamoDB GSI-based API
    const result = await execApi(
      () => getUnreadThreadMessageCountByMailIds(accessToken, {
        input: {
          accountId,
          mailIds: contactIds || []
        },
        appInfo
      }),
      (res) => res.getUnreadThreadMessageCountByMailIds
    )

    if (!result.isOk || !result.content) {
      return { buckets: [] }
    }

    // Convert to OpenSearch-compatible format
    const buckets = result.content.counts.map(({ mailId, unreadCount }) => ({
      key: mailId,
      doc_count: unreadCount
    })).filter((bucket) => bucket.doc_count > 0)

    return { buckets }
  } catch (error) {
    console.error("Error fetching unread count from DynamoDB:", error)
    return { buckets: [] }
  }
}